import { useEffect, useState } from "react";
import axios from "axios";
import { toast, Bounce } from "react-toastify";
import { useAudio, useAudioList } from "../Stores/useAudio";
import { usePlayGif, useGifList } from "../Stores/useGif";
import { getClaims, decideClaim, sendReminder, getAllValue, getBadge, deleteClaim } from "../../action";
import { useDispatch, useSelector } from "react-redux";

export const AppealInProgressRow = ({
  address,
  description,
  index,
  claimantId,
  claimantName,
  insurer,
  status,
  appealStartTime,
  timestamps
}) => {
  const jwtToken = localStorage.getItem("jwtToken");
  const [leftDays, setLeftDays] = useState(100);
  const state = useSelector((state) => state.reducer);
  const [progress, setProgress] = useState(0);
  const [open, setOpen] = useState(false);

  const keys = timestamps ? Object.keys(timestamps).sort((a, b) => new Date(timestamps[a]) - new Date(timestamps[b])) : [];
  const results = keys.map((key) => {
    const currentDate = new Date(timestamps[key]);
    const today = new Date();
    const diffTime = Math.abs(today - currentDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { timestamp: key, daysAgo: diffDays };
  });
  const { setAudioURL } = useAudio();
  const { celebrateAudios } = useAudioList();
  const { setGifSrc, setShowGif } = usePlayGif();
  const { celebrateGifs } = useGifList();
  const [appealStartFinalTime, setAppealStartFinalTime] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const start = new Date(appealStartTime);
    const end = new Date(start);
    end.setDate(start.getDate() + 30);
    const now = new Date();

    const totalDays = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
    const elapsedDays =
      (now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
    const remainingDays = Math.max(totalDays - elapsedDays, 0);

    setLeftDays(Math.ceil(remainingDays));
    setProgress(Math.min((elapsedDays / totalDays) * 100, 100));
    if (leftDays === 0) {
      dispatch(sendReminder(claimantId));
    }
  }, [appealStartTime, leftDays, dispatch, claimantId]);

  useEffect(() => {
    if (appealStartTime) {
      const dateObj = new Date(appealStartTime);
      const today = new Date();
      const origianlDate = new Date(dateObj.toDateString());
      const todayDateOnly = new Date(today.toDateString());
      const diffTime = todayDateOnly - origianlDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setAppealStartFinalTime(diffDays);
    }
  }, [appealStartTime]);

  const handleDecideAppeal = (status) => {
    if (status === "authorize") {
      axios
        .post(
          `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/appeal-decision`,
          { decision: "approved" },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.success === true) {
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
            dispatch(getClaims());
            dispatch({ type: "SET_BADGE_GIFT", payload: "Approved" })
            dispatch(getAllValue());
            if (res.data.badgeUnlock.includes("Decline Crusher")) {
              dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Overturning a denied claim" })
              setAudioURL(["/sounds/badge/badge6.mp3"]);
            } else if (res.data.badgeUnlock.includes("Appeal Winner")) {
              dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Win 3 AFCA appeals" })
              setAudioURL(["/sounds/badge/badge28.mp3"]);
            } else if (res.data.badgeUnlock !== "") {
              dispatch({ type: "SET_BADGE_GIFT", payload: `added ${res.data.badgeUnlock} badges!` })
              setAudioURL(["/sounds/badge/badge20.mp3"]);
            } else {
              setAudioURL(celebrateAudios);
            }
            dispatch(getBadge());
          }
          
          
          
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status === "lost") {
      axios
        .post(
          `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/appeal-decision`,
          { decision: "denied" },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.message)
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
          dispatch(getClaims());
          dispatch({ type: "SET_AUDIO_OH" });
          dispatch({ type: "SET_NO_GIFT" });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <tr key={index} className="border-t">
      <td className="px-6 py-4 text-center">{address}</td>
      <td className="px-6 py-4 text-center">{claimantName}</td>
      <td className="px-6 py-4 text-center">{insurer}</td>
      <td className="px-6 py-4 text-center">{description}</td>
      <td className="px-6 py-4 text-center relative">
        <div
          className="bg-blue-50 hover:bg-blue-100 px-2 py-1 border border-blue-100 rounded-2xl w-max mx-auto text-blue-700 cursor-pointer"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          {status}
          {open && (
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white shadow-lg rounded-xl p-4 w-56 z-10 text-sm">
              {results?.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <strong>{
                    item.timestamp === "createdAt" ? "Authorized" :   
                    item.timestamp === "assessmentStart" ? "Under Assessment" :
                    item.timestamp === "appealStart" ? "Appeal in Progress" :
                    item.timestamp === "afcaWonDate" ? "Scope of Works" :
                    item.timestamp === "cashSettlementDate" ? "Cash Settlement" :
                    item.timestamp === "eggHatchedDate" ? "Egg Hatched" :
                    item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                    item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                    item.timestamp === "declinedDate" ? "AFCA Claim Denied" : ""
                  }</strong>: {item.daysAgo} day{item.daysAgo !== 1 && 's'}
                </div>
            ))}
          </div>
          )}
        </div>
      </td>
      <td className="px-6 py-4 text-center">
        <div className="flex flex-col gap-y-1">
          <div className="flex justify-between text-xs">
            <p>Appeal Decision</p>
            <p>{`${leftDays} days left`}</p>
          </div>
          <div className="bg-gray-200 dark:bg-gray-200 rounded-full w-full h-2.5">
            <div
              className="bg-blue-500 rounded-full h-2.5"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="flex justify-between text-xs">
            <p>Start</p>
            <p>30 Calendar days</p>
          </div>
        </div>
      </td>
      <td className="space-y-2 px-6 py-4">
        {
          state.role === 0 && (
            leftDays === 0 ? (
              <div className="flex justify-center">
                <button className="relative w-[120px] px-4 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-red-400 to-red-600 shadow-lg hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow">
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">AFCA Threat</span>
                </button>
              </div>
            ) : null
          )
        }
        {
          state.role === 0 ? (
            <>
              {/* First Line: Approved */}
              <div className="flex justify-center">
                <button
                  onClick={() => handleDecideAppeal("authorize")}
                  className="relative w-[120px] px-4 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-green-400 to-green-600 shadow-lg hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                >
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">Approved</span>
                </button>
              </div>

              {/* Second Line: Denied & Undo */}
              <div className="flex justify-center gap-2">
                <button
                  onClick={() => handleDecideAppeal("lost")}
                  className="relative w-[120px] px-4 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-red-400 to-red-600 shadow-lg hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                >
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">Denied</span>
                </button>
                <button
                  onClick={() =>
                    dispatch(decideClaim(claimantId, "deniedUndo", jwtToken))
                  }
                  className="relative w-[120px] px-4 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-yellow-400 to-orange-600 shadow-lg hover:scale-105 hover:from-yellow-500 hover:to-orange-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                >
                  <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                  <span className="relative z-10">Undo</span>
                </button>
              </div>
            </>
          ) : (
            <button
              onClick={(e) => dispatch(deleteClaim(claimantId, state.currentUserName))}
              className="relative px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
            >
              <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
              <span className="relative z-10">Delete</span>
            </button>
          )
        }
      </td>
      <td className="text-center">
        {
          appealStartFinalTime === 0 ? "Today" : (`${appealStartFinalTime} days`)
        }
      </td>
    </tr>
  );
};
